import { createApp } from 'vue' 
import App from './App.vue'
import router from './router'
//加入http请求
import axios from 'axios'
//加入Element ui主键
import ElementPlus from 'element-plus'
//加入element的主题
import 'element-plus/dist/index.css'
// 引入全局样式
import './assets/styles/global.css'
//添加事件管理者'passive'，来阻止'touchstart'事件，让页面更加流畅。 解决chrome下的warning问题
import "default-passive-events";
//加入element ui的message box
import { ElMessageBox,ElMessage } from "element-plus"
//加入echarts 图标组件
import * as echarts from 'echarts' 
import horizontalScroll from 'el-table-horizontal-scroll'

// Vue3

const app = createApp(App)
app.use(horizontalScroll)

app.use(ElementPlus,{size:'small'})
app.config.globalProperties.$echarts = echarts
app.config.productionTip = false

// const baseURL = "https://dev.ec.3s-md.com"   //测试环境地址
// const baseURL = "/api"   //测试环境地址
// app.config.globalProperties.$userURL = "/api/user-server"
// app.config.globalProperties.$talnetURL = "/api/talnet-server"
// app.config.globalProperties.$fileURL = "/api/file-server"
// const baseURL = "http://localhost:8092"
// const baseURL = "http://139.224.73.193:1850"
const baseURL = "https://ec.3s-md.com"    //正式环境
app.config.globalProperties.$userURL = baseURL + "/user-server"
app.config.globalProperties.$talnetURL = baseURL + "/talnet-server"
app.config.globalProperties.$fileURL = baseURL + "/file-server"
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
app.config.globalProperties.$axios = axios 
app.config.globalProperties.$ElMessageBox = ElMessageBox
app.config.globalProperties.$ElMessage = ElMessage


//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => { 
    const role = sessionStorage.getItem('userInfo');
    if (!role && to.path !== '/login') {
        next('/login');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            this.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
          //next();
          
          let path = to.path;
          if(path != undefined && path != null && path.length > 0 && path.startsWith("/")){
            next();
          } else{
            this.$alert('您没有权限访问该页面！', {
                confirmButtonText: '确定'
            });
          }
        }
    }
  })

app.use(router)
app.mount('#app')